
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/userOpHash/[...slug]",
      function () {
        return require("private-next-pages/userOpHash/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/userOpHash/[...slug]"])
      });
    }
  